import React from 'react';
import { Target, Flag, Map, Brain, Shield, TrendingUp, Zap, Heart, Sparkles, Activity } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function BenefitsGrid() {
  const benefits = [{
    icon: <Target className="w-8 h-8 text-primary" data-id="element-18" />,
    title: 'Completar tus primeros 5K',
    desc: 'Aunque hoy estés completamente fuera de estado o empieces de cero.'
  }, {
    icon: <Flag className="w-8 h-8 text-primary" data-id="element-19" />,
    title: 'Dejar de abandonar',
    desc: 'Y finalmente sentir el orgullo de terminar algo que empezaste.'
  }, {
    icon: <Map className="w-8 h-8 text-primary" data-id="element-20" />,
    title: 'Saber exactamente qué hacer',
    desc: 'En cada entrenamiento, sin adivinar ni improvisar rutinas.'
  }, {
    icon: <Brain className="w-8 h-8 text-primary" data-id="element-21" />,
    title: 'Construir disciplina',
    desc: 'Sin depender de la motivación fugaz que desaparece a los pocos días.'
  }, {
    icon: <Shield className="w-8 h-8 text-primary" data-id="element-22" />,
    title: 'Evitar lesiones',
    desc: 'Y frustración con un plan progresivo diseñado para cuidar tu cuerpo.'
  }, {
    icon: <TrendingUp className="w-8 h-8 text-primary" data-id="element-23" />,
    title: 'Ganar confianza',
    desc: 'En vos mismo semana a semana al ver tu progreso real.'
  }];
  const secondaryBenefits = [{
    icon: <Zap className="w-5 h-5" data-id="element-24" />,
    text: 'Más energía'
  }, {
    icon: <Heart className="w-5 h-5" data-id="element-25" />,
    text: 'Mejor estado físico'
  }, {
    icon: <Sparkles className="w-5 h-5" data-id="element-26" />,
    text: 'Mayor claridad mental'
  }, {
    icon: <Activity className="w-5 h-5" data-id="element-27" />,
    text: 'Sensación real de progreso'
  }];
  return <section className="bg-light py-20 md:py-32" data-id="element-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-29">
        <FadeIn data-id="element-30">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-31">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-dark mb-6" data-id="element-32">
              Con este método vas a lograr{' '}
              <span className="text-primary" data-id="element-33">resultados reales</span>
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-16" data-id="element-34">
          {benefits.map((benefit, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-35">
              <div className="bg-white p-8 rounded-2xl shadow-soft border border-gray-100 h-full hover:-translate-y-1 transition-transform duration-300" data-id="element-36">
                <div className="bg-primary/10 w-16 h-16 rounded-xl flex items-center justify-center mb-6" data-id="element-37">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-bold text-dark mb-3" data-id="element-38">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-39">{benefit.desc}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-40">
          <div className="bg-dark text-white rounded-2xl p-8 md:p-12 text-center" data-id="element-41">
            <h3 className="text-2xl font-bold mb-8" data-id="element-42">
              También vas a notar en tu día a día:
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-43">
              {secondaryBenefits.map((item, index) => <div key={index} className="flex flex-col items-center gap-3" data-id="element-44">
                  <div className="bg-white/10 p-4 rounded-full text-primary" data-id="element-45">
                    {item.icon}
                  </div>
                  <p className="font-medium text-gray-300" data-id="element-46">{item.text}</p>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}